import React from "react";
import { Row } from './styles'

export default ({ data, expand}) => {
    return (
        <Row align={"top"}>
            <div>{data.office}</div>
            {expand ? <div>{data.department}</div> : null}
        </Row>
    )
}